import { useState } from 'react';

import { useUpdateSubscriptionMutation } from 'entities/tariff/api';
import { SubscriptionOrderFinal, SubscriptionResponse, TariffsResponse } from 'entities/tariff/api/contracts';
import { SubscriptionEditOrder } from 'features/tariffs/edit/ui/EditModals/EditModalContainer/EditModalContainer';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useConfigureEdit = (tariff: TariffsResponse, subscription: SubscriptionResponse) => {
	const initialOrder = {
		tariffId: tariff.id,
		legalEntityId: {
			id: subscription.legalEntityId,
			nameFull: ``,
			nameShort: ``,
		},
		contactEmail: null,
		trialId: tariff.trial?.id ?? null,
		relatedEntityIds: subscription.relatedEntityIds.map(n => n.id),
		additionalFeatures: subscription.additionalOptions.map(n => n.id),
		additionalPriceForUnit: subscription.additionalOptions
			.map(n => (n.price ? n.price : 0))
			.reduce((a, b) => a + b, 0),
		payload: null,
		addNewUnitOnOpening: subscription.addNewUnitOnOpening,
	};
	const [updateSubscription, { isLoading: isEditLoading }] = useUpdateSubscriptionMutation();
	const [subscriptionEditResponse, setSubscriptionEditResponse] = useState<SubscriptionOrderFinal>();
	const [order, setOrder] = useState<SubscriptionEditOrder>(initialOrder);

	const updateOrder = (newOrder: SubscriptionEditOrder): void => {
		setOrder(newOrder);
	};

	const resetOrder = (): void => {
		setOrder(initialOrder);
	};

	const edit = async (): Promise<void> => {
		const subscriptionRequestBody: SubscriptionOrderFinal = {
			tariffId: order.tariffId,
			relatedEntityIds: order.relatedEntityIds,
			trialId: null,
			contactEmail: order.contactEmail === `` ? null : order.contactEmail,
			legalEntityId: order.legalEntityId.id,
			additionalOptions: order.additionalFeatures,
			payload: order.payload,
			subscriptionId: subscription.id,
			addNewUnitOnOpening: order.addNewUnitOnOpening,
		};
		const res = await updateSubscription(subscriptionRequestBody).unwrap();
		setSubscriptionEditResponse(res.result);
	};

	return { order, updateOrder, edit, isEditLoading, resetOrder, subscriptionEditResponse };
};
